export default function Disclosure() {
    return <div>
        <strong>Budget helper - Google API Disclosure</strong>
        <p>
            Budget helper's use of information received from Google APIs will adhere to the <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements.
            </p>
    </div>;
}